import StyledLink from '../StyledLink'
import {
  DESIGNER,
  EDIT,
  TESTCASES
} from '../routes'
import type { Props } from '../types'

interface Params {
  testCaseId: string
}

const LinkToEditTestCase = ({
  children,
  testCaseId,
  isHyperlink
}: (Props & Params)) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={`/${DESIGNER}/${TESTCASES}/${testCaseId}/${EDIT}`}
  >
    {children}
  </StyledLink>

export default LinkToEditTestCase
